<template>

    <div class="container">
        <h2 v-html="lang('brands.title')"></h2>
        <ul>
            <li v-for="brand in allBrands">
                <inertia-link
                    :href="route('brands.item', brand.slug)"
                >
                    {{ brand.name }}
                </inertia-link>
            </li>
        </ul>
    </div>

</template>

<script>

import Layout from "../../../Shared/Layout";

export default {

    computed: {
        allBrands() {
            return this.brands.data.sort((a, b) => a.name.localeCompare(b.name));
        },
    },

    layout: Layout,

    metaInfo() {
        return {
            title: this.lang('brands.meta.title'),
            meta: [
                {vmid:'keywords',name:'keywords',content:this.lang('cart.meta.keywords')},
                {vmid:'description',name:'description',content:this.lang('cart.meta.description')},
            ],
        }
    },

    name: 'OpenBrandsIndex',

    props: {
        brands: {
            required:true,
            type: Object,
        },
    },

}

</script>
